import { get, post, put, httpDelete, urlConfig } from '../utils/request'
import {getCookie} from "../utils/common";
import node_env from "../node_env";

let preUrl = 'https://store-test.smartz.cloud' //'/web'

if(node_env === 'production'){
  preUrl = 'https://houtai.smartz.cloud'
}

// 获取订阅价格列表
export function getSubscribePriceList(data) {
  const url = preUrl + '/subscribe/plan'
  return get(url, {})
}
// 获取折扣率
export function getPromoRate(data) {
  const url = preUrl + '/cart/promo'
  return post(url, data)
}

// Checkout Order
export function checkoutOrder(data) {
  const url = preUrl + '/checkout/submit'
  return post(url, data)
}

// Generate the session to checkout order
export async function generateSession(data) {
  const url = preUrl + '/subscribe/session'
  return post(url, data)
}

// Get session status
export async function getSessionStatus(sessionId, token) {
  const url = preUrl + `/cart/session/${sessionId}/${token}`
  return get(url, {})
}

// 添加模板组件
export function addTemplateComponent(data) {
  const url = urlConfig.url + '/templates'
  return post(url, data)
}

// 更新模板组件
export function updateTemplateComponent(id, data) {
  const url = urlConfig.url + '/templates/'+ id
  return put(url, data)
}
// 删除模板组件
export function deleteTemplateComponent(id) {
  let url = urlConfig.url + '/templates/'+ id
  return httpDelete(url, {})
}

// 获取赠送的设备
export function getProductDevice(){
  const url = preUrl + `/product/list`
  return get(url, {})
}

// 获取云套餐列表
export function getCloudPlan() {
  const url = preUrl + '/subscribe/plan'
  return get(url, {})
}

// 获取网盘套餐列表
export function getVaultPlan() {
  const url = preUrl + '/vdr/plan'
  return get(url, {})
}

// 获取折扣
export function getPromoByCode(data){
  const url = preUrl + '/cart/promo'
  return post(url, data)
}

//获取Sales Tax
export function getSalesTax(state_code){
  const url = preUrl + '/cart/tax/' + state_code
  return get(url, {})
}

// 用于校验token是否有效
export function checkToken(){
  let token = getCookie('token');
  const url = preUrl + '/subscribe/list/' + token;
  return get(url, {})
}

// 获取cloud服务订单列表
export function getCloudSrvPlanList(){
  let token = getCookie('token');
  const url = preUrl + '/subscribe/list/' + token;
  return get(url, {})
}


// 更换套餐
export function changeCloudPlan(data){
  const url = preUrl + '/subscribe/change'
  return post(url, data)
}

// 获取Bundle套餐信息
export function getBundleInfo(userToken='1'){
  let url = `${preUrl}/product/bundle`;
  if(userToken){
    url = `${url}/${userToken}`
  }
  return get(url, {})
}



// WEBPACK FOOTER //
// ./src/api/subscribe.js